/**
 * 图片压缩插件 压缩至 1M 以下
 * file：文件(类型是图片格式)，
    obj：文件压缩后对象 quality(0-1)
    cb
 */
export function photoCompress(file, cb) {
  if (file.size>3*1024*1024) {
    readPhoto(file, res => {    cb(res)  },0.4)
  }else if(file.size>2*1024*1024){
    readPhoto(file, res => {    cb(res)  },0.5)
  }else if(file.size>1*1024*1024){
    readPhoto(file, res => {    cb(res)  },0.8)
  }else{
    cb(file)
  }
}

/**
 * 读取图片信息 传入文件 传出base64
 */
function readPhoto(file, callback, quality) {
  let ready = new FileReader()
  /* 开始读取指定File对象中的内容. 读取操作完成时,返回一个URL格式的字符串. */
  ready.readAsDataURL(file)
  ready.onload = function() {
    let re = this.result

    // 开始压缩

    /**
     * 利用canvas数据化图片进行压缩
     * 传入base64 传出 压缩过的base64
     */
    let img = new Image()
    img.src = re
    img.onload = function() {
      let that = this // 指到img
      // 默认按比例压缩
      let w = that.width,
        h = that.height
      quality = quality ? quality : 0.55 // 默认图片质量为0.0.92
      // 生成canvas
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      // 创建属性节点
      let anw = document.createAttribute('width')
      anw.nodeValue = w
      let anh = document.createAttribute('height')
      anh.nodeValue = h
      canvas.setAttributeNode(anw)
      canvas.setAttributeNode(anh)
      ctx.drawImage(that, 0, 0, w, h)
      // quality值越小，所绘制出的图像越模糊
        //   console.log(quality)
      let base64 = canvas.toDataURL('image/jpeg', quality)
      // 回调函数返回base64的值

      /**
       * base64 合成 图片
       * base64 转 Blob 格式 和file格式
       * 传入base64 传出 file
       */
      let arr = base64.split(','),
        mime = arr[0].match(/:(.*?);/)[1], // 去掉url的头，并转化为byte
        bstr = atob(arr[1]), // 处理异常,将ascii码小于0的转换为大于0
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      // 转blob
      // return new Blob([u8arr], {type: mime})
      let filename = Date.parse(new Date()) + '.jpg'
      // 转file
      let fi = new File([u8arr], filename, { type: mime })
    //   console.log('B-F', fi.size)
    //   if (fi.size > 1024 * 1024) {
    //     readPhoto(fi, callback, (quality - 0.1))
    //   } else {
    //     callback(fi)
    //   }
      callback(fi)
    }
  }
}
